import * as R from 'ramda';
//////////////////////////////////////////////////

const mapIdNameToValueLabelObjectProps = R.map(
  ({ id, name }) => ({ value: id, label: name }),
);

export {
  mapIdNameToValueLabelObjectProps,
};
